// extracted by mini-css-extract-plugin
export default {"row":"Adress_row__5V6S2","item":"Adress_item__sHht1"};